import React from 'react';

import { ReactComponent as IconLoaderThin } from 'media/svg/loaderThin.svg';

import styles from './loader.module.scss';

interface LoaderProps {
    customClass?: string | Record<string, unknown>;
}

const Loader = ({ customClass = '' }: LoaderProps) => {
    return (
        <div className={`${styles.LoaderSpinner} ${customClass}`}>
            <IconLoaderThin />
        </div>
    );
};

export default Loader;
